<ngx-select [multiple]="multiple" [items]="items" [disabled]="disabled" (data)="refreshValue($event)" [placeholder]="placeholder">
</ngx-select>
